/* eslint-disable import/no-cycle */
import Parent from '../views/Parent.vue';
import ListReportSetlementBni from '../views/report-settlement-bni/ListReportSettlementBni.vue';
import { setBreadcrumb } from './index';

const reportSettlementBni = {
  path: '/report-settlement-bni',
  children: [
    {
      path: '',
      meta: {
        title: 'BNI QRIS - Report Settlement BNI',
        appBarTitle: 'Report Settlement BNI',
        breadcrumbs: () => [
          setBreadcrumb(
            'Report Settlement BNI',
            '/report-settlement-bni',
            true
          ),
          setBreadcrumb('List Report Settlement BNI', '/report-settlement-bni'),
        ],
      },
      component: ListReportSetlementBni,
      name: 'ListReportSetlementBni',
    },
  ],

  meta: {
    title: 'BNI QRIS - Report Settlement BNI',
    appBarTitle: 'Report Settlement BNI',
  },
  component: Parent,
};
export default reportSettlementBni;
